<header class="content-page__header header-article" [class.has--image]="media?.absoluteUrl">
  <div class="header-article__content bg-background topbar-padding-top">
    <main class="header-article__content__inner container container-size-sm section-inset-y">
      <ng-content select="breadcrumbs"></ng-content>

      @if (subtitle) {
        <strong class="h1 text-light text-max-width-xs">
          {{ subtitle }}
        </strong>
      }

      @if (title) {
        <h1 [class.mb-0]="!intro">{{ title }}</h1>
      }
      @if (intro) {
        <p class="mb-0">{{ intro }}</p>
      }

      <!-- Button -->
      @if (button?.url) {
        <a class="button button--secondary mt-4" [href]="button?.url">
          <span>{{ button?.text || 'Shop nu' }}</span>
        </a>
      }
      @if (button?.routerLink?.length && !button?.url) {
        <a class="button button--secondary mt-4" [routerLink]="button?.routerLink">
          <span>{{ button?.text || 'Shop nu' }}</span>
        </a>
      }
      <!-- Button end -->
    </main>
  </div>
  @if (media?.absoluteUrl) {
    <div class="header-article__figure">
      <figure class="container container-size-sm">
        <!--<img
          class="header-article__figure__image"
          [src]="(media!.absoluteUrl | resize: 1200 : undefined : undefined : 'crop' : 'webp') + '&maxheight=800'"
          [alt]="media?.altText || media?.caption || title"
        />-->

        @let img = media;
        <img
          class="header-article__figure__image"
          [ngSrc]="img?.absoluteUrl || ''"
          [width]="img?.width || 1200"
          [height]="height(img?.height)"
          ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
          sizes="(max-width: 768px) 100vw,  50vw"
          [attr.data-object-position]="img?.anchor || 'middlecenter'"
          [loaderParams]="{
            anchor: img?.anchor || 'middlecenter',
            format: 'webp',
            width: img?.width || 1200,
            height: height(img?.height),
            mode: 'crop',
          }"
          [alt]="img?.altText || img?.caption || img?.absoluteUrl"
        />
      </figure>
    </div>
  }
</header>
